import React, { useState, useEffect } from "react";
import localforage from "localforage";
import "./cointrackerstyles.css"
import CoinDataItem from "./CoinDataItem";
import CoinHistoryItem from "./CoinHistoryItem";
import dataService from "../services/dataService";
import confused from "../assets/confused.png"

export default function CoinTracker() {
    const [coinData, setCoinData] = useState([])
    const [currentHistory, setCurrentHistory] = useState("")

    function displayHistory(coinId) {
        // handler forwarded to CoinDataItem
        setCurrentHistory(coinId)
    }

    function hideHistory() {
        // handler forwarded to CoinHistoryItem
        setCurrentHistory("")
    }
    useEffect(() => {
        (async () => {
            localforage.getItem("preferences").then((prefs) => {
                if (prefs != null) {
                    let coinDataListTemp = []
                    const coinDataUpdate = prefs.map((coin) => {
                        return dataService.getLiveRate(coin.coinId).then(res => {
                            const coinDataItem = { coinId: res.id, coinName: res.name, price: res.priceUsd, marketCap: res.marketCapUsd, supply: res.supply, change24Hr: res.changePercent24Hr }
                            coinDataListTemp.push(coinDataItem)
                            return coinDataItem
                        })
                    })
                    Promise.allSettled(coinDataUpdate).then(results => {
                        setCoinData(coinDataListTemp)

                    })
                }
            })
        })()

        return () => {
            // this now gets called when the component unmounts
        };
    }, [])

    if (currentHistory != "") {
        return <CoinHistoryItem coinId={currentHistory} hideHistory={hideHistory} />
    }

    else {
        if (coinData.length == 0) {
            return (
                <div className="coinTracker col center">
                   <div> Add coins to track in the preferences tab</div>
                </div>
            )
        }
        return (
            <div className="coinTracker col">
                <div className="tracker-header row">
                    <div className="header-title leftText">name</div>
                    <div className="header-title">live price</div>
                    <div className="header-title">change in 24 hrs</div>
                    <div className="header-title">market cap</div>
                    <div className="header-title">supply</div>
                    <div className="header-title">history</div>
                </div>

                <div className="coinDataList col">
                    {coinData ? coinData.map((item) => (
                        <CoinDataItem key={item.coinName} name={item.coinName} price={item.price} marketCap={item.marketCap} supply={item.supply} change24Hr={item.change24Hr} showHistory={displayHistory} id={item.coinId} />
                    )) : null}
                </div>
            </div>
        )
    }

}